<template>
  <v-container fluid>
    <div class="receipt">
      <div class="paper">
        <dl>
          <dt>Fecha de abono:{{ objetoDatosCambioDireccion.Fecha }}</dt>
          <dd>#REF: {{ objetoDatosCambioDireccion.IdEnvio }}</dd>
        </dl>
        <div v-if="objetoDatosCambioDireccion.objTotales" style="text-align:center;">
          <span><<<<<<< CAMBIO DE DIRECCIÓN >>>>>>>>></span>
          <br />
          Nombre de cliente: {{ nombreAbonante }}
        </div>
        <div v-if="!objetoDatosCambioDireccion.objTotales" style="text-align:center;">
          <span><<<<<<< CAMBIO DE DIRECCIÓN ERROR MOSTRADOR >>>>>>>>></span>
          <br />
          Nombre de cliente: {{ nombreAbonante }}
        </div>
        <div v-if="objetoDatosCambioDireccion.objTotales">
          <dl class="total">
            <dt>Costo cambio de dirección:</dt>
            <dd>
              {{ formateaMoneda(objetoDatosCambioDireccion.objTotales.CostoCambioDireccion) }}
            </dd>
          </dl>
          <dl class="total">
            <dt>Efectivo entregado:</dt>
            <dd>{{ formateaMoneda(objetoDatosCambioDireccion.objTotales.Efectivo) }}</dd>
          </dl>
          <dl class="total">
            <dt>Abono registrado:</dt>
            <dd>{{ formateaMoneda(objetoDatosCambioDireccion.objTotales.Abono) }}</dd>
          </dl>
          <dl class="total">
            <dt>Cambio cliente:</dt>
            <dd>{{ formateaMoneda(objetoDatosCambioDireccion.objTotales.Cambio) }}</dd>
          </dl>
          <dl class="total">
            <dt>Pago pendiente cambio dir.:</dt>
            <dd>
              {{ formateaMoneda(objetoDatosCambioDireccion.objTotales.DeudaCambioDireccion) }}
            </dd>
          </dl>
        </div>
        <dl>
          <dt>
            Autoriza:
          </dt>
          <dd>
            {{ logedInUserInfo.nombre }}
          </dd>
        </dl>
        ______________________________________
        <hr />
      </div>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
export default {
  props: { objetoTicketCDR: Object },
  async beforeMount() {
    await this.getSucursalEnLaQueEstoy(this.logedInUserInfo.sucursal);
  },
  computed: {
    ...mapState("enviosInfoEnvio", {
      infoEnvioActual: state => state.infoEnvio,
      infoEnvioGeneradaDespues: state => state.infoEnvioGeneradaDespues
    }),
    ...mapState("sesion", {
      sucursalInfo: state => state.sucursalData,
      logedInUserInfo: state => state.logedInUserInfo
    }),
    ...mapState("abonosEnvios", {
      objetoDatosAbonoSencillo: state => state.objetoDatosAbonoSencillo,
      objetoDatosMultiple: state => state.objetoDatosMultiple,
      objetoDatosCambioDireccion: state => state.objetoDatosCambioDireccion,
      nombreAbonante: state => state.nombreAbonante
    })
  },
  methods: {
    ...mapActions("sesion", ["getSucursalEnLaQueEstoy"]),
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    }
  }
};
</script>
<style lang="css" scoped>
* {
  font-size: 18px/1.5;
   font-family: 'Lato', sans-serif;
  box-sizing: border-box;
  align-items: left;
  letter-spacing: -1px;
  line-height: 0.9;
}
body {
  display: flex;
  height: 100vh;
  margin: 0;
  justify-content: center;
  align-items: left;
  font-size: 12px;
}
.receipt {
  align-items: left;
  word-break: break-word;
  width: 302px;
  border: 1px dotted black;
  border-width: 1px 0;
}
.receipt .paper {
  background: white;
  text-align: left;
}
.receipt h1 {
  font-size: 150%;
  margin: 0;
}
.receipt h1,
.receipt .event {
  text-align: center;
  line-height: 1;
}
.receipt dl {
  display: flex;
  flex-wrap: wrap;
  margin: 1.5em 0 0;
}
.receipt dt,
.receipt dd {
  margin: 0;
  width: 50%;
}
.receipt dd {
  text-align: right;
}
.receipt .total {
  margin: 0;
}
.receipt .total:before {
  display: block;
  width: 100%;
  text-align: right;
}
.receipt .total dt {
  text-align: right;
}
.receipt .total dd {
  padding-left: 0.5em;
  text-align: left;
}
</style>
